import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { WhyJoin } from "@/components/WhyJoin";
import { Teams } from "@/components/Teams";
import { Schedule } from "@/components/Schedule";
import { HowItWorks } from "@/components/HowItWorks";
import { Roles } from "@/components/Roles";
import { Rules } from "@/components/Rules";
import { Sponsors } from "@/components/Sponsors";
import { SignupForm } from "@/components/SignupForm";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div className="bg-[#0A0A0A] text-white min-h-screen overflow-x-hidden">
      <Navbar />
      <Hero />
      <About />
      <WhyJoin />
      <Teams />
      <Schedule />
      <HowItWorks />
      <Roles />
      <Rules />
      <Sponsors />
      <SignupForm />
      <Footer />
    </div>
  );
}
